import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import {
  SF85,
  SF85P, SF85PS, SF86
} from 'constants/formTypes';
import { isPVQForm } from 'helpers/form';
import Signature from './Signature';

export default class Medical extends ValidationElement {
  constructor(props) {
    super(props);

    this.update = this.update.bind(this);
    this.updateSignature = this.updateSignature.bind(this);
  }

  update(queue) {
    this.props.onUpdate({
      Signature: this.props.Signature,
      ...queue,
    });
  }

  updateSignature(values) {
    this.update({ Signature: values });
  }

  render() {
    const isPvq = isPVQForm(this.props.formType);

    return isPvq ? (
      <div className="medical-release">
        {i18n.m('releasesPvq.medical.contents')}
        <Signature
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props.Signature}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          LegalName={this.props.LegalName}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          onError={this.props.onError}
          // eslint-disable-next-line @typescript-eslint/unbound-method
          onUpdate={this.updateSignature}
        />
      </div>
    ) : (
      <div className="medical-release">
        {(this.props.formType === SF86)
          && i18n.m('releases.medical.contents')}
        {(this.props.formType === SF85)
          && i18n.m('releases.medical.contents')}
        {(this.props.formType === SF85P)
          && i18n.m('releases.medical.contents85p')}
        {(this.props.formType === SF85PS)
          && i18n.m('releases.medical.contents85ps')}
        <Signature
          {...this.props.Signature}
          LegalName={this.props.LegalName}
          onUpdate={this.updateSignature} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.props.onError}
        />
      </div>
    );
  }
}

Medical.defaultProps = {
  Signature: {},
  LegalName: {},
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};
